import {noop} from "lodash";
import {checkPermission, PERMISSION_DICT} from "../../utils/Users_Roles_Permission";
import {
    Create_Customer,
    Customer_Choice,
    Owner_List,
    Ticket_Assignee_List,
    Ticket_Management_List,
    Ticket_Save
} from "../../config";
import api from "../../api/api";
import {InboundsActionType} from "../inbounds/inboundsAction";
import {useState} from "react";


export const SET_TICKET_REFRESH = "SET_TICKET_REFRESH";

export const ticketManagementFilter = (data, onSuccess = noop,onError = noop) => async dispatch => {
    try {
        if (!checkPermission(PERMISSION_DICT.SupportTicketList)) return null;
        const url = `${Ticket_Management_List}`
        const response = await api.post(url,data)
        if(response?.status === 200 && response.data.code === 200){
            // dispatch({
            //     type:SystemActionType.Storage_FeeAuthority_List,
            //     payload:response.data
            // })
            onSuccess(response.data)
        } else {

            onError(response.data.msg,response?.data.code)
        }

    }
    catch (e) {
        onError(e.message)
    }
}

export const ticketDetail = (data, onSuccess = noop,onError = noop) => async dispatch => {
    if (!checkPermission(PERMISSION_DICT.SupportTicketDetail)) return null;
    const ticketId = data.ticketId
    const url = `/support/ticket/${ticketId}/detail`
    const response = await api.post(url,{ownerId:data?.ownerId})
    if(response?.status === 200 && response.data.code === 200){

        onSuccess(response.data?.data?.ticketDetailInfoResp)
    } else {

        onError(response.data.msg,response?.data.code)
    }
}




export const addTicket =  (data,onSuccess = noop, onError = noop)  => async dispatch => {
    try {

        if (!checkPermission(PERMISSION_DICT.SupportTicketCreate)) return null;
        const url = `${Ticket_Save}`
        const response = await api.post(url,{...data})
            .then(res=>res)


        if(response?.status === 200 && response.data.code === 200){

            onSuccess("TicketPage.Ticket created successfully")
        } else {
            onError(response.data.msg)
        }

    }
    catch (e) {
        onError(e.message)
    }

}

export const addTicketComment =  (data,onSuccess = noop, onError = noop)  => async dispatch => {
    try {

        const ticketId = data.ticketId
        const url = `/support/ticket/${ticketId}/comment`

        if (!checkPermission(PERMISSION_DICT.SupportTicketComment)) return null;

        const response = await api.post(url,{...data})
            .then(res=>res)

        if(response?.status === 200 && response.data.code === 200){

            onSuccess("TicketPage.Ticket Comment Added successfully")
        } else {
            onError(response.data.msg)
        }

    }
    catch (e) {
        onError(e.message)
    }

}


export const updateTicketComment =  (data,onSuccess = noop, onError = noop)  => async dispatch => {
    try {

        const ticketId = data.ticketId
        const commentId = data.commentId
        const url = `/support/ticket/${ticketId}/comment/${commentId}/edit`

        if (!checkPermission(PERMISSION_DICT.SupportTicketCommentEdit)) return null;

        const response = await api.post(url,{...data})
            .then(res=>res)

        if(response?.status === 200 && response.data.code === 200){

            onSuccess("TicketPage.Ticket Comment Edited successfully")
        } else {
            onError(response.data.msg)
        }

    }
    catch (e) {
        onError(e.message)
    }

}

export const deleteTicketComment = (data, onSuccess = noop, onError = noop) => async dispatch => {
    try {
        const { ticketId, commentIds } = data;

        if (!checkPermission(PERMISSION_DICT.SupportTicketCommentDelete)) return null;

        const url = `/support/ticket/${ticketId}/comments/delete`;

        const response = await api.post(url, {
            commentIds
        });

        if (response?.status === 200 && response.data.code === 200) {
            onSuccess("TicketPage.Ticket Comment Deleted successfully");
        } else {
            onError(response.data.msg);
        }

    } catch (e) {
        onError(e.message);
    }
};

export const getTicketAssignee = (onSuccess = noop, onError = noop)  => async dispatch => {
    try {

        if (!checkPermission(PERMISSION_DICT.SupportTicketAssignee)) return null;
        const url = `${Ticket_Assignee_List}`
        const response = await api.get(url)
            .then(res=>res)


        if(response?.status === 200 && response.data.code === 200){

            onSuccess(response.data?.data)
        } else {
            onError(response.data.msg,response?.data.code)
        }

    } catch (e) {
        onError(e.message)
    }
}


export const updateTicket =  (data,onSuccess = noop, onError = noop)  => async dispatch => {
    try {
        const ticketId = data.ticketId
        if (!checkPermission(PERMISSION_DICT.SupportTicketUpdate)) return null;
        const url = `/support/ticket/${ticketId}`
        const response = await api.post(url,{...data})
            .then(res=>res)


        if(response?.status === 200 && response.data.code === 200){

            onSuccess("TicketPage.Ticket Status Updated successfully")
        } else {
            onError(response.data.msg)
        }

    }
    catch (e) {
        onError(e.message)
    }

}


export const markCommentsAsRead = (data, onSuccess = noop, onError = noop) => async dispatch => {


    const url = `/support/ticket/comments/read`;
    if (!checkPermission(PERMISSION_DICT.SupportTicketCommentRead)) return null;
    try {
        const response = await api.post(url, data);


        if (response?.status === 200 && response.data.code === 200) {
            onSuccess(response.data?.data);
        } else {
            onError(response?.data?.msg, response?.data?.code);
        }
    } catch (err) {
        onError(err?.message);
    }
};
